import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import React, { Component } from "react";
import DATEPICKER_OR from  "../../../../../common/custom-form/custom-date-picker.component";
import Translation from "../../../../../common/translation/translation.component";
import store from "../../../../../../store";
import { actions } from 'react-redux-form';
import { orderMilestoneAction } from '../../../../../../store/external/order/milestone/order-milestone.reducer'
import { REQUEST_TYPES, QUOTATION_CODE_DETAIL } from '../../../../../../constants/external-constants';
class OrderSubmittedMilestone extends Component {
    constructor(props) {
        super(props);
        this.state={
            orderSubmitDate:null,
            circuitRequestDate:null
        }
    }

    handleOrderSubmitDate=(date)=>{
        store.dispatch(actions.change('orderMilestoneForm.orderSubmitDate',date))
    }

    handleCircuitRequestDate=(date)=>{
        store.dispatch(actions.change('orderMilestoneForm.circuitRequestedDate',date))
    }

   getCircuitDateLabel = () => {
    const { requestType } = this.props;
       const circuitRequiredTypes = [
           REQUEST_TYPES.newMobileSubscription,
           REQUEST_TYPES.simAndDevice,
           REQUEST_TYPES.newMobileDevice,
           REQUEST_TYPES.wifiDongleAndDataCard,
           REQUEST_TYPES.simAndDeviceBSA,
           REQUEST_TYPES.simOnlyBSA,
           REQUEST_TYPES.multiSIMBSA,
           REQUEST_TYPES.wifiDongleAndDataCardBIN,
           REQUEST_TYPES.voiceSIMBIN,
           REQUEST_TYPES.wifiDongleDataCardAndVoiceSIMBIN,
           REQUEST_TYPES.portOut,
           REQUEST_TYPES.replaceOrUpgradeDevice,
           REQUEST_TYPES.changeVendor,
           REQUEST_TYPES.portIn,
           REQUEST_TYPES.changeNumber,
           REQUEST_TYPES.enableHotspot,
           REQUEST_TYPES.other,
           REQUEST_TYPES.simActivation,
           REQUEST_TYPES.suspendResumeService,
           REQUEST_TYPES.pukCode,
           REQUEST_TYPES.otherSIMReplacement,
           REQUEST_TYPES.otherChangeOfPlan,
           REQUEST_TYPES.updatePlan,
           REQUEST_TYPES.terminateSubscription,
           REQUEST_TYPES.callingAccess,
           REQUEST_TYPES.roamingAccess,
           REQUEST_TYPES.newCircuit,
           REQUEST_TYPES.terminateSubscriptionWireline,
           REQUEST_TYPES.accessory,
           REQUEST_TYPES.changeUser
       ];

    return circuitRequiredTypes.includes(requestType)
        ? 'circuit_required_date'
        : 'circuit_request_date';
};

    
    componentDidMount = () =>{
        const {orderMilestoneForm} = this.props;
        this.setState({
            orderSubmitDate: orderMilestoneForm.orderSubmitDate,
            circuitRequestDate: orderMilestoneForm.circuitRequestedDate
        })
    }
    componentWillUnmount = () =>{
        const { orderMilestoneForm } = this.props;

        if (this.state.orderSubmitDate !== orderMilestoneForm.orderSubmitDate) {
            this.handleOrderSubmitDate(null);
        }
        if (this.state.circuitRequestDate !== orderMilestoneForm.circuitRequestedDate) {
            this.handleCircuitRequestDate(null);
        }
    }

    render() {
        const { orderMilestoneForm, requestType, disableFields } = this.props
        const isCircuitRequestedDateRequired = requestType === REQUEST_TYPES.portIn
            || requestType === REQUEST_TYPES.terminateSubscription
            || requestType === REQUEST_TYPES.portOut
            || requestType === REQUEST_TYPES.replaceOrUpgradeDevice
            || requestType === REQUEST_TYPES.changeUser
            || requestType === REQUEST_TYPES.changeVendor
            || requestType === REQUEST_TYPES.accessory
            || requestType === REQUEST_TYPES.intlRoamAccess
            || requestType === REQUEST_TYPES.other
            || requestType === REQUEST_TYPES.changeNumber
            || requestType === REQUEST_TYPES.enableHotspot
            || requestType === REQUEST_TYPES.simActivation
            || requestType === REQUEST_TYPES.suspendResumeService
            || requestType === REQUEST_TYPES.pukCode
            || requestType === REQUEST_TYPES.otherSIMReplacement
            || requestType === REQUEST_TYPES.otherChangeOfPlan
            || requestType === REQUEST_TYPES.newMobileSubscription
            || requestType === REQUEST_TYPES.simAndDevice
            || requestType === REQUEST_TYPES.newMobileDevice
            || requestType === REQUEST_TYPES.wifiDongleAndDataCard
            || requestType === REQUEST_TYPES.simAndDeviceBSA
            || requestType === REQUEST_TYPES.simOnlyBSA
            || requestType === REQUEST_TYPES.multiSIMBSA
            || requestType === REQUEST_TYPES.wifiDongleAndDataCardBIN
            || requestType === REQUEST_TYPES.voiceSIMBIN
            || requestType === REQUEST_TYPES.wifiDongleDataCardAndVoiceSIMBIN
            || requestType === REQUEST_TYPES.newCircuit
            || requestType === REQUEST_TYPES.updatePlan
            || requestType === REQUEST_TYPES.callingAccess
            || requestType === REQUEST_TYPES.roamingAccess
            || requestType === REQUEST_TYPES.terminateSubscriptionWireline ? false : true;
        return(
            <div className={`order-milestone__form message-form-body ${this.props.customClass}`} > 
                    <DATEPICKER_OR
                    dateOnly={true}
                    label={<Translation translationKey={'order_submit_date'} />}
                    startDate={orderMilestoneForm.orderSubmitDate}
                    selectedDate={(date) => this.handleOrderSubmitDate(date)}
                    requiredField={true}
                    isDisable={disableFields}
                    />
                    { requestType !== REQUEST_TYPES.newQuotation
                        && requestType !== QUOTATION_CODE_DETAIL.newQuotation 
                        && requestType !== QUOTATION_CODE_DETAIL.upgradeQuotation ?
                    <DATEPICKER_OR
                    dateOnly={true}
                    label={<Translation translationKey={this.getCircuitDateLabel ()} />}
                    startDate={orderMilestoneForm.circuitRequestedDate}
                    selectedDate={(date) => this.handleCircuitRequestDate(date)}
                    requiredField={isCircuitRequestedDateRequired}
                    isDisable={disableFields}
                    />  : null
                    }
                    
            </div>  
        )
    }
}

export default connect(
    state => {
        const { orderMilestoneDetails,
            form: { forms: { orderMilestoneForm: { $form } } },
        } = state;
        const { orderMilestoneForm } = state.form;
        return {
            
            orderMilestoneForm,
            orderMilestoneDetails,
            $form
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, orderMilestoneAction),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
    })
)(OrderSubmittedMilestone);